<mic-modal #modalExportFiles>
  <ng-template #contentModalExportFiles>
    <div class="flex flex-col gap-4">
      @if (loadingList) {
        <div class="p-4">
          <mic-spinner ariaLabel="In Progress" color="primary" [strokeWidth]="5"></mic-spinner>
        </div>
      }
      @if (!loadingList) {
        <div>
          <mic-table #table class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
            <ng-container *micCellTemplate="let item; name: 'actionsCell'">
              <div class="flex flex-row gap-4">
                <button mat-icon-button color="primary" matTooltipClass="big-tooltip" matTooltip="Download"
                  (click)="download(item)">
                  <mat-icon>download</mat-icon>
                </button>
              </div>
            </ng-container>
          </mic-table>
        </div>
      }
      @if (!loadingList) {
        <div class="flex flex-row-reverse">
          <button mat-flat-button color="primary" class="mic-btn-icon-left" (click)="generateNewFile()">
            <mat-icon>note_add</mat-icon><span>Gerar Arquivo</span>
          </button>
        </div>
      }
    </div>
  </ng-template>
</mic-modal>